import './ArrowButton.scss';

import type { ModifiersType } from '@utils';
import { createClsNameMap, mapModifiers, mergeModifiers } from '@utils';

const clsNameMap = createClsNameMap({
  elements: {
    icon: createClsNameMap(),
    path: createClsNameMap({
      modifiers: ['filter'],
    }),
  },
  modifiers: ['right', 'bottom', 'filter'],
})('arrow-button');

export type ArrowButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  modifiers?: ModifiersType<typeof clsNameMap>;
  label?: string;
  isFilter?: boolean;
};

const ArrowButton = ({ modifiers, label, isFilter = false, ...otherProps }: ArrowButtonProps) => {
  return (
    <button aria-label={label} {...otherProps} className={mergeModifiers(clsNameMap, [modifiers])}>
      <svg
        className={clsNameMap.elm('icon')}
        xmlns='http://www.w3.org/2000/svg'
        width='7'
        height='12'
        role='img'
        viewBox='0 0 7 12'
        fill='none'
      >
        <path
          className={mapModifiers(clsNameMap.path, { filter: isFilter })}
          d='M6.58942 0.610713C6.26398 0.285274 5.73635 0.285274 5.41091 0.610713L0.611415 5.41021C0.455135 5.56649 0.366829 5.77895 0.366829 5.99996C0.366829 6.22098 0.454629 6.43294 0.610909 6.58922L5.41091 11.3892C5.73635 11.7147 6.26398 11.7147 6.58942 11.3892C6.91486 11.0638 6.91486 10.5362 6.58942 10.2107L2.37867 5.99996L6.58942 1.78922C6.91486 1.46379 6.91486 0.936153 6.58942 0.610713Z'
        />
      </svg>
    </button>
  );
};

export default ArrowButton;
